import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { Button, Paper } from 'library';

import './ShareYourStoryBlock.scss';

const ShareYourStoryBlock = () => {
  const {
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "hometap_houses.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <Paper theme="medium" pad={1}>
      <div className="ShareYourStoryBlockWrap">
        <h3>Have a great experience with Hometap?</h3>
        <Button
          theme="outlined"
          href="https://docs.google.com/forms/d/e/1FAIpQLSesgGynqwOH1Z6XwKxCJ0f4zVSqpxZ0epL_dBg2k4xSE79OEQ/viewform"
          className="cta-segment-track"
        >
          Share your story
        </Button>
      </div>
      <div className="ShareYourStoryBlockWrap">
        <Img fluid={fluid} alt="Share your story block image" />
      </div>
    </Paper>
  );
};

export default ShareYourStoryBlock;
